'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { BackButton } from '@royalaholddelhaize/ah-customer-care-components/elements';
import { useHasOrigin } from './hooks/use-has-origin';

export const WebviewBackButton: React.FC = () => {
    const hideBackButton = useHasOrigin('Appie');
    const router = useRouter();

    const handleClick = () => {
        router.back();
    };

    if (hideBackButton) {
        return null;
    }

    return <BackButton onClick={handleClick} />;
};
